import React from 'react';
import {
    Col,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Button
} from "reactstrap";
import ToastHelper from '../../helpers/ToastHelper';
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useMutation } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { UPDATE_ONE_ATTENDANCE_STEP } from '../../graphql/mutation/UPDATE_ONE_ATTENDANCE_STEP';

function EditTier(props) {

    const { modal, toggleModal, tier } = props;

    const [updateOneStep] = useMutation(UPDATE_ONE_ATTENDANCE_STEP);

    return (
        <React.Fragment>
            <Modal isOpen={modal} role="dialog" size="lg" autoFocus={true} centered={true} id="verificationModal" tabIndex="-1" toggle={toggleModal}>
                <div className="modal-content new-bonus-page">
                    <ModalHeader toggle={toggleModal}>
                        Edit Tier
                    </ModalHeader>
                    <ModalBody>
                        <div id="new-bank-wizard" className="twitter-bs-wizard">
                            <AvForm className="needs-validation"
                                onValidSubmit={async (event, values) => {
                                    await updateOneStep({
                                        variables: {
                                            input: {
                                                update: {
                                                    step: parseFloat(values.step),
                                                    rewardPoint: parseFloat(values.rewardPoint),
                                                },
                                                id: tier.node.id
                                            }
                                        }
                                    }).catch(e => {
                                        ToastHelper.toggleToast({
                                            toastType: "error",
                                            message: e,
                                            title: "",
                                            onClick: function () { }
                                        })
                                    }).then(val => {
                                        if (val) {
                                            ToastHelper.toggleToast({
                                                message: "Create Succesfully!",
                                                title: "",
                                                onClick: function () { }
                                            })
                                            toggleModal()
                                        }
                                    })
                                }}
                                onInvalidSubmit={() => {

                                }}
                            >
                                <Row>
                                    <Col lg={6}>
                                        <AvField
                                            value={tier.node.step}
                                            label="Step"
                                            name="step"
                                            type="text"
                                            placeholder="Enter Step"
                                            errorMessage="Enter Step"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            value={tier.node.rewardPoint}
                                            label="Reward Point"
                                            name="rewardPoint"
                                            type="text"
                                            placeholder="Enter Reward Point"
                                            errorMessage="Enter Reward Point"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                </Row>
                                {
                                    <div className="action-container">
                                        <Button color="primary" type="submit">Submit</Button>
                                    </div>
                                }
                            </AvForm>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default connect()(withTranslation()(EditTier));